import React from 'react';
import {Table, TableBody, TableCell, TableHead, TableRow, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {DetailedCheckResponse} from '../../../../store/models/DuplicateCheck';

interface SummaryRow {
    label: string;
    original?: string;
    normalized?: string;
    indent?: boolean;
}

const useStyles = makeStyles((theme) => ({
    indentCell: {
        paddingLeft: theme.spacing(3.5),
        color: theme.palette.text.secondary,
    },
}));

export default function InputSummaryPanel({input}: {input: DetailedCheckResponse['input']}) {
    const classes = useStyles();

    const rows: SummaryRow[] = [
        {label: 'Firmenname', original: input.companyName?.original, normalized: input.companyName?.normalized},
        {label: 'Telefon', original: input.phone?.original, normalized: input.phone?.normalized},
        {label: 'Website', original: input.website?.original, normalized: input.website?.normalized},
        {label: 'Adresse', original: input.address?.original},
    ];

    if (input.address) {
        const {extractedStreet, extractedHouseNumber, extractedZipCode, extractedCity} = input.address;
        if (extractedStreet) rows.push({label: 'Straße', normalized: extractedStreet, indent: true});
        if (extractedHouseNumber) rows.push({label: 'Hausnummer', normalized: extractedHouseNumber, indent: true});
        if (extractedZipCode) rows.push({label: 'PLZ', normalized: extractedZipCode, indent: true});
        if (extractedCity) rows.push({label: 'Ort', normalized: extractedCity, indent: true});
    }

    rows.push({
        label: 'Geo',
        original: input.geo ? `${input.geo.lat}, ${input.geo.lng}` : undefined,
    });

    return (
        <Table size="small">
            <TableHead>
                <TableRow>
                    <TableCell>Feld</TableCell>
                    <TableCell>Eingabe</TableCell>
                    <TableCell>Normalisiert / Geparst</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {rows.map((r) => (
                    <TableRow key={r.label}>
                        <TableCell className={r.indent ? classes.indentCell : undefined}>
                            {r.indent ? `↳ ${r.label}` : r.label}
                        </TableCell>
                        <TableCell>
                            {r.original
                                ? r.original
                                : !r.indent
                                    ? <Typography variant="caption" color="textSecondary">nicht angegeben</Typography>
                                    : null
                            }
                        </TableCell>
                        <TableCell>
                            {r.normalized
                                ? r.normalized
                                : r.original
                                    ? <Typography variant="caption" color="textSecondary">—</Typography>
                                    : <Typography variant="caption" color="textSecondary">
                                        {r.indent ? 'nicht erkannt' : 'nicht angegeben'}
                                    </Typography>
                            }
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
}
